package com.bikompanion.domain

data class BikeStation(
    val id: String,
    val name: String,
    /** The network this station belongs to, so the UI can offer its operator's app. */
    val networkId: String = "",
    val latitude: Double,
    val longitude: Double,
    val freeBikes: Int,
    val emptySlots: Int,
    val electricBikes: Int = 0,
    val supportsElectricBikes: Boolean = false,
) {
    val normalBikes: Int get() = freeBikes - electricBikes
    val capacity: Int get() = freeBikes + emptySlots
}
